import { formatDistanceToNowStrict } from "date-fns";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { useSyncStatus } from "@/sync/hooks";

export function SyncIndicator() {
	const { status, pending, lastSyncedAt } = useSyncStatus();
	const offline = status === "offline";
	const label = offline
		? `Offline · ${pending} change${pending === 1 ? "" : "s"} queued`
		: pending
			? `Saving ${pending} change${pending === 1 ? "" : "s"}…`
			: lastSyncedAt
				? `Synced ${formatDistanceToNowStrict(lastSyncedAt, { addSuffix: true })}`
				: "Synced";

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<span className="mono-label flex items-center gap-1.5" aria-live="polite">
					<span
						className={cn(
							"size-1.5 rounded-full bg-foreground/70",
							pending > 0 && !offline && "animate-dot-pulse",
							offline && "bg-transparent ring-1 ring-foreground/60",
						)}
					/>
					{offline ? "Offline" : pending ? "Saving" : "Synced"}
				</span>
			</TooltipTrigger>
			<TooltipContent side="top">{label}</TooltipContent>
		</Tooltip>
	);
}
